<mat-form-field appearance="fill" style="width: 100% !important; height: 48px;" class="login-signup-form-desing app__checklist-form-field" [ngClass]="{ 'dropdown-open': panelOpen, 'has-selection': itemsLength > 0 }">
  @if(isCustomKey){
  <mat-select
    #mySelect
    placeholder="{{title}}"
    [panelClass]="nonVaultClassName ? nonVaultClassName : 'move-select-popup'"
    [(value)]="itemType"
    [multiple]="isMultiSelect"
    (selectionChange)="handleSelectChange($event)"
    (openedChange)="panelOpen = $event"
  >

  <mat-select-trigger>
    <span class="inline-label mt-[-5px]">{{ title }}</span>
    @if (itemsLength > 0) {
    <span class="app__checklist__filter-count top-0 right-0 text-[14px]">{{ itemsLength }}</span>
    }
  </mat-select-trigger>
    
    <!-- Fixed Search Input at Top -->
    <div class="sticky top-[-8px] bg-white z-10 p-3  ">
      <div class="relative">
        <input 
          type="text" 
          placeholder="Search {{ title }}" 
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent"
          [(ngModel)]="searchText"
          (input)="onSearchInput($event)"
        />
        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </span>
      </div>
    </div>

    <!-- Scrollable Options Container -->
    <div class="overflow-y-auto options-scroll-container" >
      @if(filteredList.length > 0) {
        @for (item of filteredList; track $index) {
        <mat-option [value]="item[valueKey]" [class]="'app__mat-option'">
          <div appTooltip [toolTipText]="item[lableKey]" class="shared-drop-down-ellipsis">
            {{ item[lableKey] }}
          </div>
        </mat-option>
        }
      } @else {
        <div class="px-3 py-4 text-center text-gray-500 text-sm">
          No results found
        </div>
      }
    </div>
   
      <div class="sticky bottom-[-10px] bg-white z-10 border-t border-gray-200" *ngIf="isMultiSelect">
        <button 
          (click)="clearAllSelections()"
          class="w-full px-3 py-3 bg-[#FFFFFF] text-[#25508E] rounded-md hover:bg-[#EBF0FA] transition-colors duration-200 text-sm font-medium"
        >
          Clear All
        </button>
      </div>
    
  </mat-select>
  }@else{
  <ng-container>
    @if(isTwoWay){
    <mat-select
      #mySelect
      placeholder="{{title}}"
      [panelClass]="nonVaultClassName ? nonVaultClassName : 'move-select-popup'"
      [(value)]="itemType"
      multiple
      (selectionChange)="handleSecondFilterChange()"
      (openedChange)="panelOpen = $event"
    >
    <mat-select-trigger>
      <span class="inline-label mt-[-5px]">{{ title }}</span>
      @if (itemsLength > 0) {
      <span class="app__checklist__filter-count top-0 right-0 text-[14px]">{{ itemsLength }}</span>
      }
    </mat-select-trigger>
    
      <!-- Fixed Search Input at Top -->
      <div class="sticky top-[-8px] bg-white z-10 p-3   ">
        <div class="relative">
          <input 
            type="text" 
            placeholder="Search {{ title }}" 
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent"
            [(ngModel)]="searchText"
            (input)="onSearchInput($event)"
          />
          <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </span>
        </div>
      </div>

      <!-- Scrollable Options Container -->
      <div class="overflow-y-auto options-scroll-container" style="max-height: calc(100vh - 200px);">
        @if(filteredList.length > 0) {
          @for (status of filteredList; track $index) {
          <mat-option [value]="status.type" [class]="'app__mat-option'" (click)="handleFilterChange(status)">
            <div appTooltip [toolTipText]="status?.type ?? 'type'" class="shared-drop-down-ellipsis">
              {{ status?.type ?? 'type' }}
            </div>
          </mat-option>
          }
        } @else {
          <div class="px-3 py-4 text-center text-gray-500 text-sm">
            No results found
          </div>
        }
      </div>
        <div class="sticky bottom-0 bg-white z-10 border-t border-gray-200">
          <button 
            (click)="clearAllSelections()"
            class="w-full px-3 py-3 bg-[#FFFFFF] text-[#25508E] rounded-md hover:bg-[#EBF0FA] transition-colors duration-200 text-sm font-medium"
          >
            Clear All
          </button>
        </div>
      
    </mat-select>
    }@else{
    <mat-select
      #mySelect
      placeholder="{{title}}"
      [panelClass]="nonVaultClassName ? nonVaultClassName : 'move-select-popup'"
      [(value)]="itemType"
      multiple
      (selectionChange)="handleSecondFilterChange($event)"
      (openedChange)="panelOpen = $event"
    >
    <mat-select-trigger>
      <span class="inline-label mt-[-5px]">{{ title }}</span>
      @if (itemsLength > 0) {
      <span class="app__checklist__filter-count top-0 right-0 text-[14px]">{{ itemsLength }}</span>
      }
    </mat-select-trigger>
    
      <!-- Fixed Search Input at Top -->
      <div class="sticky top-[-8px] bg-white z-10 p-3 ">
        <div class="relative">
          <input 
            type="text" 
            placeholder="Search {{ title }}" 
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent"
            [(ngModel)]="searchText"
            (input)="onSearchInput($event)"
          />
          <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </span>
        </div>
      </div>

      <!-- Scrollable Options Container -->
      <div class="overflow-y-auto options-scroll-container" style="max-height: calc(100vh - 200px);">
        @if(filteredList.length > 0) {
          @for (status of filteredList; track $index) {
          <mat-option
            color="red"
            [value]="!isObject ? status : hasClass ? status.status : useType ? status.type : status"
            [class]="hasClass ? status?.val : 'app__mat-option'"
            (click)="handleFilterChange(status)"
          >
            <div
              appTooltip
              [toolTipText]="!isObject ? status : useName ? status?.name : useNickName ? status?.nick_name : status?.type"
              class="shared-drop-down-ellipsis"
            >
              {{ !isObject ? status : useName ? status?.name : useNickName ? status?.nick_name : status?.type }}
            </div>
          </mat-option>
          }
        } @else {
          <div class="px-3 py-4 text-center text-gray-500 text-sm">
            No results found
          </div>
        }
      </div>
      
     
        <div class="sticky bottom-0 bg-white z-10 border-t border-gray-200">
          <button 
            (click)="clearAllSelections()"
            class="w-full px-3 py-2 bg-[#FFFFFF] text-[#1E40AF] rounded-md hover:bg-[#EBF0FA] transition-colors duration-200 text-sm font-medium"
          >
            Clear All
          </button>
        </div>
     
    </mat-select>
    }
  </ng-container>
  }
</mat-form-field>
